












import {Component, Prop, Vue, Watch} from 'vue-property-decorator';

@Component
export default class Heading extends Vue {
  @Prop()
  protected h1?: string;
  @Prop()
  protected description?: string;
}
